import { Formatters, Messages } from '../../codegen/Localize';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { IProjectInfo } from '../models/IProjectInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Projects } from '../resources/Projects';
import { IResult } from '../ServerApi/types/IResponse';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ProjectErrors } from './ProjectErrors';

export class DeleteProjectsAction {

  public static $inject = ['ProjectErrors', 'ActionHelpers', 'ConfirmActionDialog', 'Projects'];

  constructor(
    private ProjectErrors: ProjectErrors,
    private ActionHelpers: ActionHelpers,
    private ConfirmActionDialog: ConfirmActionDialog,
    private Projects: Projects) { }

  public confirmDeleteProjects(projects: Set<IProjectInfo>, context: IActionContext): ng.IPromise<IResult> {
    const confirmDialog = this.ConfirmActionDialog.open({
      scope: context.scope,
      title: Messages.deleteMessage(),
      bodyText: DeleteProjectsAction.getConfirmationDialogBodyText(projects),
      actionName: Messages.confirmDeleteButton({
        ITEM_COUNT: projects.size(),
        ITEM_COUNT_LOC: Formatters.formatCount(projects.size())
      }),
      isDeleteAction: true,
      action: (dialogInstance: IConfirmActionDialogInstance) => null
    });

    return confirmDialog.result.then(() => {
      confirmDialog.dismiss();
      return this.showAreYouSureDialog(projects, context.scope);
    });
  }

  private static getConfirmationDialogBodyText(projects: Set<IProjectInfo>) {
    if (projects.size() === 1) {
      const projectName = L10n.elideIfLong(projects.first().name);
      return Messages.confirmDeleteSpecificProject({ PROJECT_NAME: projectName });
    }

    return Messages.confirmDeleteProjects({ formattedProjectCount: Formatters.formatCount(projects.size()) });
  }

  private showAreYouSureDialog(projects: Set<IProjectInfo>, scope: ng.IScope) {
    return this.ConfirmActionDialog.open({
      scope: scope,
      title: Messages.confirmAreYouSure(),
      bodyText: Messages.actionNotUndoable(),
      areYouReallySure: true,
      actionName: Messages.confirmDeleteProjectsDefinitely({ PROJECT_COUNT: projects.size() }),
      isDeleteAction: true,
      action: (dialogInstance: IConfirmActionDialogInstance) => this.deleteProjectsAndNotifyResult(projects)
    }).result;
  }

  private deleteProjectsAndNotifyResult(projects: Set<IProjectInfo>) {
    return this.Projects.del(projects.keys()).then((result: IResult) => this.notifyResult(projects, result));
  }

  private notifyResult(projects: Set<IProjectInfo>, result: IResult) {
    this.ActionHelpers.notifyStandardError(
      projects,
      {
        successId: 'deleteProjectsSuccess',
        errorId: 'deleteProjectsError'
      },
      (errorItem: IErrorItem<IProjectInfo>) => this.ProjectErrors.errorDetailsFor(errorItem))(result);
  }

}

Module.instance().service('DeleteProjectsAction', DeleteProjectsAction);
